<div class="left-0 max-h-full overflow-y-auto fixed right-0 top-1/2 transform -translate-y-1/2">
  <div class="mx-auto text-center">
    <div class="p-5 py-7.5 header-logo align-middle"></div>
    <div id="content" class="p-5">
      <h1><span class="block text-9xl">404</span><span class="text-3xl">File not found</span>
      </h1>
      <button
        color="primary"
        mat-flat-button
        class="mt-8"
        [routerLink]="'/buildings'">
        Return to the main page
      </button>
    </div>
    <div id="footer" class="p-5">
      <div class="inline-block p-2 align-top whitespace-nowrap"><a href="http://organicresponse.com">© Organic Response, 2016 - 2025</a></div>
      <div class="inline-block p-2 align-top whitespace-nowrap"><a href="http://organicresponse.com/our-purpose/">About</a></div>
      <div class="inline-block p-2 align-top whitespace-nowrap"><a href="http://organicresponse.com/contact-us/">Contact</a></div>
      <div>
        <div class="inline-block p-2 align-top whitespace-nowrap">
          <a href="http://www.linkedin.com/company/2537887?trk=prof-exp-company-name">
            <span class="bg-bottom or-icon or-tiny or-active or-icon-linkedin"></span>
            <span class="inline-block align-middle ml-1.5 mr-1.5 leading-4">LinkedIn</span>
          </a>
        </div>
        <div class="inline-block p-2 align-top whitespace-nowrap">
          <a href="https://twitter.com/organicresponse">
            <span class="bg-bottom or-icon or-tiny  or-active or-icon-twitter"></span>
            <span class="inline-block align-middle ml-1.5 mr-1.5 leading-4">Twitter</span>
          </a>
        </div>
        <div class="inline-block p-2 align-top whitespace-nowrap">
          <a href="https://www.facebook.com/Organic-Response-188173324646681/">
            <span class="bg-bottom or-icon or-tiny or-active or-icon-facebook"></span>
            <span class="inline-block align-middle ml-1.5 mr-1.5 leading-4">Facebook</span>
          </a>
          </div>
      </div>
    </div>
  </div>
</div>
